<template>
    <div class="report-card">
        <!-- 顶部：时间 + 状态 -->
        <div class="top-row">
            <div class="time-label">报告时间：</div>
            <div class="time-val">{{ item.genDate || '--' }}</div>
            <div class="status-tag" :class="statusClass">{{ statusText }}</div>
        </div>
        <div class="divider"></div>

        <!-- 调研问卷 -->
        <div class="row pt-30">
            <div class="label">调研问卷</div>
            <div class="value ellipsis">{{ item.questionnaireName }}</div>
        </div>

        <!-- 走访轮次 -->
        <div class="row">
            <div class="label">走访轮次</div>
            <div class="value">{{ item.visitRound }}</div>
        </div>

        <!-- 得分 + 操作按钮 -->
        <div class="row pb-30 score-row">
            <div class="score-left">
                <div class="label">报告得分</div>
                <div class="score">{{ item.score ?? '-' }}</div>
                <div class="score-tag" :class="scoreClass">{{ scoreLabel }}</div>
            </div>
            <div class="actions">
                <div class="btn dark" v-if="item.reportStatus != 0 && item.reportStatus != 1 && item.reportStatus != 5" @click="$emit('track', item)">问题跟踪</div>
                <div class="btn dark" v-if="showViewBtn(item.reportStatus)" @click="$emit('view', item)">{{ item.reportStatus == 0 ? '预览' : '查看' }}报告</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'InspectReportItem',
        props: {
            item: { type: Object, required: true },
            postType: { type: Number, default: 1 }
        },
        computed: {
            statusText() {
                const map = { 0: '走访中', 1: '审核中', 2: '整改中', 3: '申诉中', 4: '已完成', 5: '得分计算中' }
                return map[this.item.reportStatus] || ''
            },
            statusClass() {
                const map = { 0: 'red', 1: 'red', 2: 'red', 3: 'red', 4: 'black', 5: 'grey' }
                return map[this.item.reportStatus] || 'black'
            },
            scoreLabel() {
                const s = Number(this.item.score)
                if (isNaN(s) || s == '') return ''
                if (s < 60) return '不及格'
                if (s <= 70) return '一般'
                if (s < 85) return '良好'
                return '优秀'
            },
            scoreClass() {
                const s = Number(this.item.score)
                if (isNaN(s) || s == '') return ''
                if (s < 60) return 'score-red'
                if (s <= 70) return 'score-yellow'
                if (s < 85) return 'score-orange'
                return 'score-green'
            },
        },
        methods: {
            showViewBtn(status) {                
                // 门店主任权限
                const isStoreManager = this.postType >= 1 && this.postType <= 4 && status <= 4 && status >= 2
                // 质检专员权限
                const isQualityInspector = this.postType == 9 || this.postType == 10
                return isStoreManager || isQualityInspector
            }
        }
    }
</script>

<style scoped lang="less">
    .report-card {
        margin: 20px 30px;
        background: #fff;
        border-radius: 30px;
        box-shadow: 0 6px 18px rgba(16, 24, 40, 0.06);
    }

    .top-row {
        display: flex;
        align-items: center;
        padding: 20px 30px;
    }

    .time-label {
        color: #798A94;
        font-size: 26px;
    }

    .time-val {
        margin-left: 12px;
        color: #798A94;
        font-size: 26px;
        flex: 1;
    }

    .status-tag {
        padding: 0 16px;
        height: 48px;
        line-height: 48px;
        border-radius: 24px;
        font-size: 26px;
    }

    .status-tag.red {
        color: #F65252;
    }

    .status-tag.black {
        color: #333F48;
    }

    .status-tag.grey {
        color: #798A94;
    }

    .divider {
        height: 1px;
        background: #D7D7D7;
    }

    .row {
        display: flex;
        align-items: center;
        padding: 15px 20px;
    }

    .label {
        width: 120px;
        color: #798A94;
        font-size: 26px;
    }

    .value {
        flex: 1;
        color: #35434C;
        font-size: 26px;
    }

    .ellipsis {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .score-row {
        justify-content: space-between;
    }

    .score-left {
        display: flex;
        align-items: center;
    }

    .score {
        color: #35434c;
        font-size: 26px;
    }

    .score-tag {
        margin-left: 12px;
        height: 44px;
        line-height: 44px;
        padding: 0 10px;
        border-radius: 22px;
        font-size: 22px;
    }

    .actions {
        display: flex;
        align-items: center;
        gap: 12px;
    }

    .btn {
        min-width: 160px;
        height: 60px;
        line-height: 60px;
        padding: 0 18px;
        text-align: center;
        border-radius: 30px;
        font-size: 26px;
    }

    .btn.dark {
        background: #2d3a41;
        color: #fff;
    }

    .pt-30 {
        padding-top: 30px;
    }

    .pb-30 {
        padding-bottom: 30px;
    }


    /* 不及格 - 红色 */
    .score-red {
        color: #F65252;
        border: 2px solid #F65252;
    }

    /* 一般 - 黄色 */
    .score-yellow {
        color: #E9D81A;
        border: 2px solid #E9D81A;
    }

    /* 良好 - 橙色 */
    .score-orange {
        color: #F7A63B;
        border: 2px solid #F7A63B;
    }

    /* 优秀 - 绿色 */
    .score-green {
        color: #2FD0D5;
        border: 2px solid #2FD0D5;
    }
</style>